<template lang="pug">
    .reaction
       label.checkbox
         input(
          type="checkbox"
          v-bind:name="getUniqueInformationName"
          :disabled="answered == true"
          v-model="value"
          )
         | &nbsp; {{ getContent }}
</template>
<script>
    import store from '@/store';
    import { mapGetters } from 'vuex'
    export default {
       name: 'Radio',
       props: {
         inputType: {
          type: String,
          required: true
         },
         content: {
          type: Object,
          required: true
         },
         information: {
          type: Object,
          required: true
         },
         answered: {
          type: Boolean
         },
         reaction: {
          type: Object,
          required: true
         },
         section: {
                type: Object,
                required: true
            }
       },
       computed: {
         getUniqueInformationName() {
          return 'multi-choice-ID' + this.information.id
         },
         getContent() {
          return this.content.title
         },
         value: {
                get() {
                    return this.content.text
                },
                set(value) {
                    const payload = {
                        value,
                        page: parseInt(this.currentPageId),
                        information: this.information,
                        reaction: this.reaction,
                        section: this.section
                    }
                    store.commit(`currentPage/evaluationReactionInputFieldValue`, payload)
                }
            },
            ...mapGetters({
                currentPageId: 'currentPage/id',
         })
       }
    }
</script>
<style lang="sass">
    
</style>